/*
 *  Copyright (C) Healabs 2022 - All Rights Reserved
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *
 */

import pread from '@/modules/patients/store/pread'

export default {
  namespaced: true,
  modules: {
    pread
  }
}
